export class WaterPressureDto {
  readonly timestamp: string;
  readonly value: number;

  constructor(dto: WaterPressureDto) {
    this.timestamp = dto.timestamp;
    this.value = dto.value;
  }
}
